import Mustache from 'mustache'
const Property_Input_Widget_Button_Copy_Form_Data = function (opts) {
    // this.input_type = 'charcoal/admin/property/input/widgetbutton';
    Charcoal.Admin.Property.call(this, opts)

    this.input_id = '';
    this.property = null;
    this.obj_type = null;
    this.properties_to_copy = null;

    this.set_properties(opts)

    this.element().on('click', (event) => this.copyData(event))
};

Property_Input_Widget_Button_Copy_Form_Data.prototype = Object.create(Charcoal.Admin.Property.prototype);
Property_Input_Widget_Button_Copy_Form_Data.prototype.constructor = Property_Input_Widget_Button_Copy_Form_Data;
Property_Input_Widget_Button_Copy_Form_Data.prototype.parent = Charcoal.Admin.Property.prototype;

Property_Input_Widget_Button_Copy_Form_Data.prototype.set_properties = function (opts) {
    this.input_id = opts.id || this.input_id;
    this.property = opts.data.property || this.property;
    this.obj_type = opts.data.obj_type || this.obj_type;
    this.properties_to_copy = opts.data.properties_to_copy || this.properties_to_copy;

    return this;
};

Property_Input_Widget_Button_Copy_Form_Data.prototype.copyData = function (event) {
    const data = {
        obj_id: $(`select[name='${this.property}']`).val(),
        obj_type: this.obj_type,
        properties_to_copy: this.properties_to_copy,
    }

    $.ajax({
        url: Charcoal.Admin.admin_url() + 'object/copy-form-data',
        type: 'GET',
        data: data,
        error: function (response) {
            if (response.feedbacks) {
                Charcoal.Admin.feedback(response.feedbacks).dispatch();
            }
        },
        success: function (response) {
            if (response.feedbacks) {
                Charcoal.Admin.feedback(response.feedbacks);
            }

            if (!response.success) {
                return
            }

            const properties = response.properties;
            const propertyLabels = response.property_labels;

            const tableTemplate = `
<table class="table table-striped table-bordered">
<tbody>
    {{#properties}}
    <tr>
        <th scope="col">{{label}}</th>
        <td>{{value}}</td>
    </tr>
    {{/properties}}
</tbody>
</table>
`;

            const mustacheData = {
                properties: [],
            };
            for (let property in properties) {
                mustacheData.properties.push({
                    label: propertyLabels[property] ?? property,
                    value: properties[property] ?? ' - ',
                })
            }
            let tableHtml = Mustache.render(tableTemplate.trim(), mustacheData);
            tableHtml = tableHtml.replace(/\s+/g, ' ').trim();
            Charcoal.Admin.feedback([{
                level: 'warning',
                type: 'warning',
                message: "<p>Importé ces données : </p>"+tableHtml
            }])
                .add_action({
                    label:    'Cancel',
                    cssClass: 'btn-danger',
                    callback: function () {
                        BootstrapDialog.closeAll();
                    }
                })
                .add_action({
                    label:    'Continue',
                    callback: function () {
                        //TODO THIS IS NOT IDEAL ... In the future,
                        // receiving an instance of BootstrapDialog would be better,
                        // unfortunately, this is not the case. Good day sir.
                        BootstrapDialog.closeAll();

                        for (let property in properties) {
                            $(`[name=${property}]`).each(function () {
                                $(this).val(properties[property]).trigger('change')
                                // hack to support selectize input
                                if ($(this).data('selectize') ?? false) {
                                    const value = {
                                        label: properties[property],
                                        value: properties[property],
                                    }
                                    const selectize = $(this)[0].selectize;
                                    if (!selectize.options[value.value]) {
                                        selectize.addOption(value);
                                    }

                                    selectize.setValue(value.value);
                                    $(this).trigger('change')
                                }

                                if (($(this).selectpicker instanceof Function)) {
                                    setTimeout(() => {
                                        $(this).selectpicker('val', properties[property]);
                                    }, 100)
                                }

                            })
                        }
                    }.bind(this)
                }).dispatch();
        }
    });
};

Charcoal.Admin.Property_Input_Widget_Button_Copy_Form_Data = Property_Input_Widget_Button_Copy_Form_Data;
